const state = {
  jobList: [],
  activeJob: null,
  manualActivations: [],
  inboxJobs: [],
  messageToSend: {},
  unattendedMessages: [],
  disableConversationTab: false,
  inTransferAssisted: false,
  transferAssistedAccepted: false,
  transferAssistedWaitingConfirmation: false,
  ackCallRequest: {
    dialog: false,
    inprogress: false,
    info: {},
  },
  backupProtocols: [],
  disabledJobItems: false,
  channel: null,
  lastMessages: {},
};

export default state;
